// extracted by mini-css-extract-plugin
export default {"header":"Menu_header__vtcKr","nav":"Menu_nav__KkqrL","lista":"Menu_lista__E9UQj","hamburguer":"Menu_hamburguer__OkRF7","aberta":"Menu_aberta__+cihl"};